// import config from 'config';
import { apiConstants } from "../_constants";
import { authHeader, handleResponse } from "../_helpers";
export const answerService = {

    answerAdd,
    getAnswers,
    deleteAnswer,
    getProgress,
    getEdraaquizProgress,
};


function answerAdd(data) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(apiConstants.apiUrl + "/addanswer", requestOptions).then(
        handleResponse
    );
}
function getAnswers(data) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(apiConstants.apiUrl + "/getanswers", requestOptions).then(
        handleResponse
    );
}
function deleteAnswer(data) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(apiConstants.apiUrl + "/deleteanswer", requestOptions).then(
        handleResponse
    );
}
function getProgress(data) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(apiConstants.apiUrl + "/getprogress", requestOptions).then(
        handleResponse
    );
}
function getEdraaquizProgress(data) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(apiConstants.apiUrl + "/getedraaquizprogress", requestOptions).then(
        handleResponse
    );
}

